import React from 'react'
import UspsDefault from './UspsDefault'
import UspsImageCards from './UspsImageCards'
import UspsDarkOverlay from './UspsDarkOverlay'
import UspsWeHelpYou from './UspsWeHelpYou'
import UspsAmenities from './UspsAmenities'

const DESIGNS = {
  'default': UspsDefault,
  'image-cards': UspsImageCards,
  'dark-overlay': UspsDarkOverlay,
  'wehelpyou': UspsWeHelpYou,
  'amenities': UspsAmenities,
}

export default function Usps({className = '', key, index, ...props}) {

  console.log('🔍 USPs Debug:', {
    design: props.usps?.design,
    fieldGroupName: props.usps?.fieldGroupName,
    hasTextCardHeading: !!props.usps?.textCard?.heading?.[0]?.text,
  })

  const section = props.usps

  if(!section || !section.usps || !section.usps.length > 0){
    return null
  }

  const design = (props.usps?.design || 'default').trim().toLowerCase()
  const DesignComponent = DESIGNS[design] || UspsDefault
  return <DesignComponent section={section} index={index} className={className} />
}